export const TOP_ADVOCATES_COLOR_LIST = [
  "#725BFF",
  "#27F2D4",
  "#F44061",
  "#372EB3",
  "#F6E05E",
]
